<template>
  <div id="app">
    <pop-ups/>
    <all-modals/>
    <page-header/>
    <router-view/>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { APP_NAME } from "@/constants";
import { removeCookies } from "@/util";
import PageHeader from "@/components/main/page-header";
import AllModals from "@/components/modals";
import PopUps from "@/components/main/pop-ups";

export default {
  components: { PageHeader, AllModals, PopUps },
  created() {
    if (Cookies.get("token") && Cookies.get("origin") !== APP_NAME) {
      removeCookies();
      location.reload();
    }
  }
};
</script>